<template>
	<div>
		<section class="search-results" :class="{ 'is-search-map': isShowSearchMap }">
			<div class="blur-overlay" v-if="isBlurSearchResults" @click="hideSearchResultsBlur()"></div>

			<!-- Trips in comparison -->
			<button type="button" class="btn btn-primary btn-lg btn-round comparison-btn fadeInUp animated" v-if="$root.tripsInComparison.length > 0">
				{{ $root.tripsInComparison.length }}
				<span v-if="$root.tripsInComparison.length === 1">
					{{ 'general.types.tripSingular' | trans }}
				</span>
				<span v-if="$root.tripsInComparison.length !== 1">
					{{ 'general.types.tripPlural' | trans }}
				</span>
				{{ 'general.compare' | trans }}
			</button>

			<div v-if="isSearchLoading && !isPartLoading" class="loading-view">
				<i class="fa fa-spinner-third fa-spin fa-spin-fast"></i>
			</div>
			
			<!-- All view -->
			<div class="countries-view" v-if="searchResultsView === 'all' && isSearchLoading === false">
				<div class="container-fluid">
					<h1>{{ 'general.allCountries' | trans }}</h1>
				</div>

				<div v-for="(countries, continentName) in groupedCountries">
					<div class="container-fluid">
						<h2>
							{{ continentName }}
							<small>&bull; {{ countries.reduce(function(total, country) { return parseInt(country.itemsTotal, 10) + total; }, 0) | formatNumber }} {{ 'general.types.tripPlural' | trans }}</small>
						</h2>
						<div class="row" v-for="section in $lodash.chunk(countries, 4)">
							<div class="col-sm-3" v-for="group in section">
								<div class="country-tile" @click="$root.$refs.filterbar.filterCountry(group.name)">
									<div class="image">
										<span class="temperature" v-if="parseInt(group.avgAirTemperature, 10) > 0">
											<span class="air">
												<i class="wa-icon-sun"></i>
												{{ parseInt(group.avgAirTemperature, 10) }}&#8451;
											</span>

											<!--<span class="water">
												<i class="wa-icon-water-temperature"></i>
												@{{ parseInt(group.avgWaterTemperature, 10) }}&#8451;
											</span>-->
										</span>

										<img :src="$cdn.default + 'countries/' + group.image + '?width=300&height=300'" :srcset="$cdn.default + 'countries/' + group.image + '?width=300&height=300 1x,' + $cdn.default + 'countries/' + group.image + '?width=600&height=600 2x'" />
									</div>

									<div class="info">
										<h3>{{ group.name }}</h3>
										<small class="parent-name" v-if="group.parentName.length > 0">
											{{ group.parentName }} &bull; {{ group.itemsTotal | formatNumber }} {{ 'tiles.region.trips' | trans }}
										</small>
										<span class="price">ab {{ group.price.amount | formatPrice }} €</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- View header -->
			<div class="view-header" v-bind:style="{ 'background-image': 'url(' + $cdn.default + (searchResultsView === 'country' ? 'countries' : 'regions') + '/' + searchResultsHeader.image + '?width=1800&height=800)' }"  v-if="searchResultsHeader && (!isSearchLoading || isPartLoading)">
				<div class="container-fluid">
					<h1>{{ searchResultsHeader.name }}</h1>
					<span class="parent-name" v-if="searchResultsHeader.subtitle.length > 0">{{ searchResultsHeader.subtitle }}</span>
					<span class="parent-name" v-if="searchResultsHeader.subtitle.length === 0">{{ searchResultsHeader.parentName }}</span>
				</div>
			</div>

			<!-- Country view -->
			<div class="container-fluid country-view" v-if="searchResultsView === 'country' && isSearchLoading === false">
				<h2>
					{{ 'general.targetRegions' | trans }}
					<small v-if="resultsCount > 0">
						{{ items[0].groups.length | formatNumber }}
						<span v-if="items[0].groups.length !== 1">{{ 'general.places' | trans }}</span>
						<span v-if="items[0].groups.length === 1">{{ 'general.place' | trans }}</span>

						{{ 'general.and' | trans }}

						{{ resultsCount | formatNumber }}
						<span v-if="resultsCount !== 1">{{ 'general.types.tripPlural' | trans }}</span>
						<span v-if="resultsCount === 1">{{ 'general.types.tripSingular' | trans }}</span>
						{{ 'general.found' | trans }}
					</small>
				</h2>

				<div class="row" v-for="section in groupedRegions">
					<div class="col-sm-4" v-for="group in section">
						<div class="region-tile" @click="$root.$refs.filterbar.filterRegion(group.name)">
							<div class="image">
								<img :src="$cdn.default + 'regions/' + group.image + '?width=140&height=150'" :srcset="$cdn.default + 'regions/' + group.image + '?width=140&height=150 1x,' + $cdn.default + 'regions/' + group.image + '?width=280&height=300 2x'" />
							</div>

							<div class="info">
								<!--<small class="parent-name" v-if="group.parentName.length > 0">@{{ group.parentName }}</small>-->
								<small class="items-count">{{ group.itemsTotal }} {{ 'tiles.region.trips' | trans }}</small>
								<h3>{{ group.name }}</h3>
								<p class="subtitle">{{ group.subtitle }}</p>

								<span class="price">
									{{ 'tiles.region.from' | trans }} <strong>{{ group.price.amount }} €</strong>
								</span>

								<span class="temperature">
									<span class="air">
										<i class="wa-icon-sun"></i>
										{{ parseInt(group.avgAirTemperature, 10) }}&#8451;
									</span>
									<span class="water">
										<i class="wa-icon-water-temperature"></i>
										{{ parseInt(group.avgWaterTemperature, 10) }}&#8451;
									</span>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Region view -->
			<div class="container-fluid region-view" v-if="searchResultsView === 'region' && (!isSearchLoading || isPartLoading)">
				<slot name="breadcrumb"
				v-bind:country="$root.$refs.filterbar.country"
				v-bind:country-url="$root.$refs.filterbar.buildSearchUrl('region').url"
				v-bind:region="$root.$refs.filterbar.region"></slot>

				<!-- Heading -->
				<div class="heading">

					<!-- Sorting -->
					<div class="sorting">
						<span>{{ 'general.sortedBy' | trans }}</span>

						<select v-model="sorting" class="form-control" @change="search()">
							<option value="hotelRating">
								{{ 'general.sorting.hotelRating' | trans }}
							</option>
							<option value="priceAsc">
								{{ 'general.sorting.priceAsc' | trans }}
							</option>
							<option value="priceDesc">
								{{ 'general.sorting.priceDesc' | trans }}
							</option>						
							<option value="hotelCategory">
								{{ 'general.sorting.hotelCategory' | trans }}
							</option>
							<option value="hotelName">
								{{ 'general.sorting.hotelName' | trans }}
							</option>
							<option value="location">
								{{ 'general.sorting.location' | trans }}
							</option>
							<option value="startDate">
								{{ 'general.sorting.startDate' | trans }}
							</option>
						</select>
					</div>
					
					<h2 v-if="resultsCount > 0">
						<small>
							{{ resultsCount | formatNumber }}
							<span v-if="resultsCount !== 1">{{ 'general.types.tripPlural' | trans }}</span>
							<span v-if="resultsCount === 1">{{ 'general.types.tripSingular' | trans }}</span>
							{{ 'general.found' | trans }}
						</small>
					</h2>
				</div>

				<div class="alert alert-info" role="alert" v-if="resultsCount === 0">
					<h4 class="alert-heading">
						{{ resultsCount | formatNumber }}
						<span v-if="resultsCount !== 1">{{ 'general.types.tripPlural' | trans }}</span>
						<span v-if="resultsCount === 1">{{ 'general.types.tripSingular' | trans }}</span>
						{{ 'general.found' | trans }}
					</h4>
					<hr />
					<p class="mb-0">Wir haben leider keine Reise gefunden, die zu Deinen Suchkriterien passt.</p>
				</div>
				
				<!-- Items -->
				<div class="items">
					<!-- Without search map -->
					<div class="row" v-for="items in groupedItems4" v-if="!isShowSearchMap">
						<div class="col-sm-3" v-for="item in items">
							<trip-tile :item="item" :image-width="300" :image-height="260"></trip-tile>
						</div>
					</div>

					<!-- With search map -->
					<div class="row" v-for="items in groupedItems3" v-if="isShowSearchMap">
						<div class="col-sm-4" v-for="item in items">
							<trip-tile :item="item" :image-width="240" :image-height="210"></trip-tile>
						</div>
					</div>
				</div>

				<!-- Search map -->
				<div class="search-map" v-show="isShowSearchMap" ref="resultsMapParent">
					<div class="map" :style="searchMapStyles" :class="searchMapClasses" ref="resultsMap"></div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	props: ['searchEndpoint'],
	data: function() {
		return {
			isBlurSearchResults: false,
			isSearchLoading: false,
			isPartLoading: false,
			items: [],
			isMounted: false,
			sorting: 'hotelRating',

			//Map
			showSearchMap: true,
			map: null,
			bounds: null,
			markers: [],
			mapElement: null,
			mapParentElement: null
		}
	},
	mounted: function() {
		this.isMounted = true;

		//Map
		this.bounds = new google.maps.LatLngBounds();
	},
	updated: function() {
		if (this.mapParentElement === null || this.mapParentElement === undefined) {
			this.mapParentElement = this.$refs.resultsMapParent;
		}

		if (this.mapElement === null || this.mapElement === undefined) {
			this.mapElement = this.$refs.resultsMap;
			this.updateMap();
		}
	},
	watch: {
		items: function() {
			this.updateMap();
		},
		searchResultsView: function() {
			$(window).scrollTop(0);
		}
	},
	computed: {
		groupedCountries: function() {
			//return _.chunk(this.searchResults, 6);
			return this.$lodash.groupBy(this.items, 'parentName')
		},
		groupedRegions: function() {
			if (this.items.length === 0) return [];

			return this.$lodash.chunk(this.items[0].groups, 3);
		},
		groupedItems3: function() {
			if (this.searchResultsView === 'region' && this.items !== null && this.items.length > 0) {
				return this.$lodash.chunk(this.items[0].groups[0].items, 3);
			}

			return [];
		},
		groupedItems4: function() {
			if (this.searchResultsView === 'region' && this.items !== null && this.items.length > 0) {
				return this.$lodash.chunk(this.items[0].groups[0].items, 4);
			}

			return [];
		},
		searchResultsView: function() {
			//all, country, region
			if (!this.isMounted) return 'all';
			//if (typeof(this.$root.$refs.filterbar) === 'undefined') return 'all';

			if (this.$root.$refs.filterbar.country == null && this.$root.$refs.filterbar.region === null) {
				return 'all';
			} else if (this.$root.$refs.filterbar.country !== null && this.$root.$refs.filterbar.region === null) {
				return 'country';
			} else if (this.$root.$refs.filterbar.country !== null && this.$root.$refs.filterbar.region !== null) {
				return 'region';
			}

			return 'all';
		},
		searchResultsHeader: function() {
			if (typeof(this.items[0]) === 'undefined') {
				return false;
			}

			//Country
			if (this.searchResultsView === 'country') {
				if (this.items[0].image === null) return false;

				return {
					'name': this.items[0].name,
					'parentName': this.items[0].parentName,
					'subtitle': this.items[0].subtitle,
					'image': this.items[0].image
				};
			}

			//Region
			if (this.searchResultsView === 'region') {
				if (this.items[0].groups[0].image === null) return false;

				return {
					'name': this.items[0].groups[0].name,
					'parentName': this.items[0].groups[0].parentName,
					'subtitle': this.items[0].groups[0].subtitle,
					'image': this.items[0].groups[0].image
				};
			}
		},
		isShowSearchMap: function() {
			return ['region'].indexOf(this.searchResultsView) >= 0 && this.showSearchMap === true;
		},
		searchMapStyles: function() {
			var width = null;
			if (this.mapParentElement !== undefined && this.mapParentElement !== null) {
				width = $(this.mapParentElement).width();
			}

			return {
				height: (this.$root.windowHeight - 60 - 60) + 'px',
				width: width + 'px'
			}
		},
		searchMapClasses: function() {
			var itemsTop = 0;
			if (typeof($(this.$el.querySelector('div.items')).offset()) !== 'undefined') {
				itemsTop = $(this.$el.querySelector('div.items')).offset().top - 60 - 60 - 30;
			}

			return {
				'fixed-top': this.$root.windowScrollTop >= itemsTop && this.$root.windowScrollTop > 0
			};
		},
		resultsCount: function() {
			if (this.items.length === 0) return 0;

			if (typeof(this.items[0].itemsTotal) !== 'undefined') {
				return this.items[0].itemsTotal;
			}

			return 0;
		}
	},
	methods: {
		hideSearchResultsBlur: function() {
			this.isBlurSearchResults = !this.isBlurSearchResults;

			if (typeof(this.$root.$refs.filterbar) !== 'undefined') {
				this.$root.$refs.filterbar.cancelAll();
			}
		},
		searchQuery: function() {
			var search = queryString.parse(window.location.search);
			if (typeof(search.country) !== 'undefined') {
				delete search.country;
			}
			if (typeof(search.region) !== 'undefined') {
				delete search.region;
			}
			if (typeof(search.hotelCategory) !== 'undefined') {
				delete search.hotelCategory;
			}

			search = window.queryString.stringify(search);

			return (search.length > 0 ? '?' + search : '');
		},
		search: function(initial = false) {
			this.isSearchLoading = true;
			if (this.searchResultsView === 'region') this.isPartLoading = true;

			var scrollTop = this.items.length > 0 && initial === true ? false : true;

			var self = this;
			var params = this.$root.$refs.filterbar.buildParams();

			//Sorting
			params.sorting = this.sorting;

			//Make request
			axios.get(this.searchEndpoint, {
				params: params
			}).then(function (response) {
				self.items = response.data.results;

				self.isSearchLoading = false;
				self.isPartLoading = false;
				self.isBlurSearchResults = false;

				//Scroll top
				if (!scrollTop) {
					var scrollX = $('section.search-results').offset().top - 60;

					if (self.searchResultsView === 'region') {
						scrollX = $('section.search-results div.heading').offset().top - 60 - 40;
					}
					$('html,body').stop().animate({
						scrollTop: scrollX
					}, 1000);
				}
			}).catch(function (error) {
				console.log(error);
				alert('Error. Please check the console.');
			});
		},
		updateMap: function() {
			if (this.searchResultsView === 'region' && this.items.length > 0 && this.mapElement !== null && this.mapElement !== undefined) {
				const mapCentre = this.items[0].groups[0].items[0].location;

				this.map = new google.maps.Map(this.mapElement, {
					center: new google.maps.LatLng(mapCentre.latitude, mapCentre.longitude)
				});

				this.items[0].groups[0].items.forEach((item) => {
					const position = new google.maps.LatLng(item.location.latitude, item.location.longitude);
					const marker = new google.maps.Marker({ 
						position,
						map: this.map
					});
					this.markers.push(marker)
					this.map.fitBounds(this.bounds.extend(position))
				});
			}
		}
	}
}
</script>